<template>
<div class="chapter">
<div class="inner_page">
<div id="d2-d5f88a5f148ed-d1e467">
<h2 class="chapter-number ">THREE</h2>
<h2 class="chapter-title ">US Capitol, Washington, DC</h2>
<div class="section" id="d2-d5f88a5f148ed-d1e472">
<h3 class="a-head-space-after italic "><em><em class="char-italic italic">May 7, 1958</em></em></h3>
<p class="flush-left-opener " style="text-indent:0;"><span class="drop-cap char-drop-cap">T</span>he last of the eight senators returning from their lunch break seat themselves in order of seniority and political party at one end of the ornate meeting room of the Special Committee on Space and Aeronautics. Chairman Lyndon Johnson waits until the massive oak door at the far end is closed and the Congressional aides and reporters in the gallery have taken their seats before gaveling the day’s session back to order.</p>
<p class="indented ">The tall Texan has to hunch down slightly to speak into his microphone as he addresses bald, bespectacled Dr Franz Faber sitting across the way at the witness table.</p>
<p class="indented ">‘Welcome back, Dr Faber. Before lunch we were discussing the staffing of this proposed agency, and I asked you why so many of your recommendations have German names. Do you recall the question?’</p>
<p class="indented ">Faber’s lips move, but his reply can’t be heard.</p>
<p class="indented ">Chairman Johnson says, ‘Sir, you will need to turn your microphone back on.’</p>
<p class="indented ">There’s general laughter in the room as Dr Faber looks for the on-off switch. After a moment his lawyer, sitting beside him, reaches across and turns it on.</p>
<p class="indented ">The chagrined witness leans forward and says in a thick German accent, ‘This is better, yes?’</p>
<p class="indented ">‘Yes, much better, sir.’</p><span id="page8">
<p class="indented ">Faber, not a public speaker, sits uncomfortably at the edge of his chair in order to reach the microphone.</p>
<p class="indented ">‘Then may I to make clear? I do not suggest for Dr von Braun and our group be named to this new agency. Rather, we remain in the Alabama and with the new NASA I liaise, if that is in English a word.’</p>
<p class="indented ">Silver-haired Stuart Symington, the senior senator from Missouri, quips, ‘French. Close enough.’</p>
<p class="indented ">There’s more laughter among the onlookers. Symington’s Republican counterpart, the equally silver-haired Senator Everett Dirksen, waits for the mirth to subside before speaking.</p>
<p class="indented ">‘The underlying question is, uh, still on the table, sir.’</p>
<p class="indented ">The man at the table is puzzled. ‘Question?’</p>
<p class="indented ">Dirksen continues, ‘Why so many Germans?’</p>
<p class="indented ">‘You ask, sir, why are we German?’ Dr Faber appears confused. ‘Because, um, we were born there.’</p>
<p class="indented ">This time, even some of the senators are laughing. Symington, whose legislation they’re discussing, hastens to add, ‘And because, uh, let the record show, that Dr Faber and his colleagues at Peenemunde, among them Dr von Braun, surrendered to our army in May 1945, rather than to the Russians. Isn’t that right, sir?’</p>
<p class="indented ">Faber, dabbing at the sweat on his forehead with his handkerchief, says with gratitude, ‘Just so,’ before slumping back in his chair.</p></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781448303595_epub_chap004.vue?1924a027